// extracted by mini-css-extract-plugin
export var modalActionsWrapper = "components-modals-__EditPassword-module___modalActionsWrapper";
export var passwordInput = "components-modals-__EditPassword-module___passwordInput";
export var passwordInputsWrapper = "components-modals-__EditPassword-module___passwordInputsWrapper";
export var passwordsAndValidationWrapper = "components-modals-__EditPassword-module___passwordsAndValidationWrapper";
export var validationWrapper = "components-modals-__EditPassword-module___validationWrapper";